import { inject } from "@angular/core";
import { ResolveFn, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { Observable, EMPTY, switchMap, take } from "rxjs";
import { environment } from "src/environments/environment";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { ResolverHelper } from "./resolver.helper";

export const AppraisalResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    //const hasRealtorAppraisal = toSignal(ResolverHelper.hasPermission(authService, EVServiceType.Appraisal_Realtor));

    const queryParams = route.queryParams;
    //todo: reinstate open and edit when roles and pages are in place
    //const hasOpenRef = queryParams.hasOwnProperty("open");
    //const hasEditRef = queryParams.hasOwnProperty("edit");
    const hasValidateRef = queryParams.hasOwnProperty("validate");

    // if (hasOpenRef && hasRealtorAppraisal()) {
    //     const openRef: string = queryParams["open"] != null ? queryParams["open"].toString() : "";
    //     const url = environment.evwebUrl + "/infopage/appraisal;openRef=" + openRef;
    //     window.open(url, "_self");
    //     return EMPTY;
    // }
    // if (hasEditRef && hasRealtorAppraisal()) {
    //     const editRef: string = queryParams["edit"] != null ? queryParams["edit"].toString() : "";
    //     const url = environment.evwebUrl + "/infopage/appraisal;editRef=" + editRef;
    //     window.open(url, "_self");
    //     return EMPTY;
    // }
    if (hasValidateRef) {
        return ResolverHelper.hasPermission(authService, [EVServiceType.Appraisal_Bank]).pipe(
            take(1),
            switchMap((hasBankAppraisal) => {
                if (hasBankAppraisal) {
                    const url = environment.evwebUrl + "/infopage/shareinfo?appraisalId=" + queryParams["validate"].toString();
                    window.open(url, "_self");
                    return EMPTY;
                } else {
                    return ResolverHelper.redirectToFrontPage(authService, router);
                }
            }),
        );
    } else {
        return ResolverHelper.redirectToFrontPage(authService, router);
    }
};
